import type { Initiative, OverviewPeriod, OverviewQuery } from "../overviewTypes";

interface Props {
  query: OverviewQuery;
  departmentOptions: Array<{ id: string; label: string }>;
  initiatives: Initiative[];
  programmeYear: string;
  paid: boolean;
  onChange: (query: OverviewQuery) => void;
  onLogInitiative: () => void;
  onReport: () => void;
  onExportCSV: () => void;
  canExport: boolean;
  canWriteInitiative?: boolean;
}

export default function FilterRow({ query, departmentOptions, initiatives, programmeYear, paid, onChange, onLogInitiative, onReport, onExportCSV, canExport, canWriteInitiative = true }: Props) {
  const selectClass = "mt-1 w-full rounded border border-pd-rule bg-pd-white px-3 py-2 text-sm text-pd-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";
  return <section aria-label="Overview filters" className="flex flex-wrap items-end gap-3 py-4">
    {departmentOptions.length > 1 ? <label className="min-w-0 text-xs font-medium text-pd-slate">Department
      <select className={selectClass} value={query.department} onChange={event => onChange({ ...query, department: event.target.value })}>
        {departmentOptions.map(option => <option key={option.id} value={option.id}>{option.label}</option>)}
      </select>
    </label> : <p className="py-2 text-sm text-pd-slate">All departments</p>}
    <label className="text-xs font-medium text-pd-slate">Reporting period
      <select className={selectClass} value={query.period} disabled={Boolean(query.initiativeId)} aria-describedby={query.initiativeId ? "initiative-period-note" : undefined} onChange={event => onChange({ ...query, period: event.target.value as OverviewPeriod })}>
        <option value="programme_year">Programme year {programmeYear}</option><option value="this_term">This term</option><option value="last_term">Last term</option>
      </select>
    </label>
    {paid ? <>
      <label className="min-w-0 text-xs font-medium text-pd-slate">Whole-school initiative
        <select className={selectClass} value={query.initiativeId || ""} onChange={event => event.target.value === "log" ? onLogInitiative() : onChange({ ...query, initiativeId: event.target.value || undefined })}>
          <option value="">No initiative selected</option>
          {initiatives.map(initiative => <option key={initiative.id} value={initiative.id}>{initiative.name}{initiative.scope === "group" ? " (group · read-only)" : ""}</option>)}
          {canWriteInitiative ? <option value="log">Log an initiative</option> : null}
        </select>
      </label>
      <div className="flex flex-wrap gap-2 md:ml-auto">
        <button id="overview-report-top" type="button" onClick={onReport} className="rounded border border-pd-rule bg-pd-white px-3 py-2 text-sm font-medium text-pd-ink">Governors' report</button>
        {canExport ? <button type="button" onClick={onExportCSV} className="rounded border border-pd-rule bg-pd-white px-3 py-2 text-sm font-medium text-pd-ink">Export report</button> : null}
      </div>
    </> : null}
    {query.initiativeId ? <p id="initiative-period-note" className="w-full text-xs text-pd-slate">Initiative dates replace the reporting period. Clear the initiative to change it.</p> : null}
  </section>;
}
